import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { IntegrationLogo } from "../integration-logo";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export function Endpoint({
  label,
  url,
  hint,
  logo,
}: {
  label: string;
  url: string;
  hint?: string;
  logo?: string;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="space-y-1.5">
      <Label className="flex items-center gap-1.5">
        {logo && <IntegrationLogo id={logo} className="size-3.5" />}
        {label}
      </Label>
      <div className="flex gap-2">
        <Input readOnly value={url} className="font-mono text-xs" onFocus={(e) => e.target.select()} />
        <Button
          variant="outline"
          size="icon"
          aria-label={`Copy ${label} URL`}
          onClick={() => {
            void navigator.clipboard.writeText(url);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1500);
          }}
        >
          {copied ? <Check /> : <Copy />}
        </Button>
      </div>
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
